module.exports = __webpack_public_path__ + "img/titan-crystal.dec02ff8.png";